import axios from 'axios';
import { configs } from '../app/app-configs';
import { MealItemProgressRequest, MealItemProgressResponse, MemberNutritionDayResponse, NutritionPlan, NutritionPlanRequest } from './model/nutrition.model';

export const getNutritionPlans = async (memberId: number): Promise<NutritionPlan[]> => {
    return await axios.get(`${configs.BASE_URL}/nutrition-plans/member/${memberId}`).then((res) => {
        return res.data;
    });
};

// export const getTodayPlan = async (memberId: number): Promise<DaySnapshot> => {
//     return await axios.get(`${configs.BASE_URL}/nutrition-plans/member/${memberId}/today`).then((res) => {
//         return res.data;
//     });
// };

export const getActivePlan = async (memberId: number): Promise<NutritionPlan> => {
    return await axios.get(`${configs.BASE_URL}/nutrition-plans/member/${memberId}/active`).then((res) => {
        return res.data;
    });
};

export const getPlan = async (planId: number): Promise<NutritionPlan> => {
    return await axios.get(`${configs.BASE_URL}/nutrition-plans/${planId}`).then((res) => {
        return res.data;
    });
};

export const createNutritionPlan = async (
    request: NutritionPlanRequest
): Promise<NutritionPlan> => {
    return await axios
        .post(`${configs.BASE_URL}/nutrition-plans/member/${request.memberId}`, request)
        .then((res) => {
            return res.data as NutritionPlan;
        });
};

export const updateNutritionPlan = async (
    request: NutritionPlanRequest
): Promise<NutritionPlan> => {
    return await axios
        .put(`${configs.BASE_URL}/nutrition-plans/${request.id}`, request)
        .then((res) => {
            return res.data as NutritionPlan;
        });
};

export const deleteNutritionPlan = async (id: number): Promise<number> => {
    return await axios
        .delete(`${configs.BASE_URL}/nutrition-plans/${id}`)
        .then((res) => {
            return res.data;
        });
};

export const updateMealItemProgress = async (
    request: MealItemProgressRequest
): Promise<MealItemProgressResponse> => {
    return await axios
        .put(`${configs.BASE_URL}/nutrition-plans/meal-items/progress`, request)
        .then((res) => {
            return res.data as MealItemProgressResponse;
        });
};

export const getNutritionPlanDay = async (day: string): Promise<MemberNutritionDayResponse> => {
    return await axios.get(`${configs.BASE_URL}/nutrition-plans/member/day?date=${day}`).then((res) => {
        return res.data;
    });
};
